import { observer } from 'mobx-react';
import { CheckboxRequirementType } from '.';
import CheckBox from './CheckBox';

interface Props {
  tableColCount: number;
  checkBoxRequirement: CheckboxRequirementType;
  tableRowCount: number;
}

function TableBody({ tableRowCount, tableColCount, checkBoxRequirement }: Props) {
  return [...Array(tableRowCount)].map((_, rowIndex) => (
    <tr
      key={rowIndex}
      className="bg-white border-b bg-white hover:bg-gray-50 dark:hover:bg-gray-600"
    >
      <CheckBox checkboxRequirement={checkBoxRequirement} />
      {[...Array(tableColCount)].map((_, colIndex) => (
        <td key={colIndex} className="p-4">
          <div className="w-full h-4 bg-gray-300 rounded"></div>
        </td>
      ))}
      <td className="p-4">
        <div className="w-2 h-6 bg-gray-300 rounded"></div>
      </td>
    </tr>
  ));
}

export default observer(TableBody);
